module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-4.5a6c4cb3.jpg";